// header
const HeaderComponent = (function HeaderComponent() {
    const mobileNavBreakpoint = 1024;
    let mainNav = document.querySelector(".main-nav");
    // let overlay = document.querySelector(".overlay");
    let body = document.querySelector("body");
    let mobileMenuBtn = document.querySelector(".mobile-menu-toggle");
    let showNestedLevelLinks = document.querySelectorAll(".open-nested-level");
    let closeNestedLevelLinks = document.querySelectorAll(".close-nested-level");
    let mobileSearchOpen = document.querySelector(".mobile-search");
    let mobileSearchClose = document.querySelector(".site-search-close");
    let siteSearchBar = document.querySelector(".site-search");
    let siteHeader = document.querySelector(".site-header") || document.querySelector("header");

    function attachEvents() {
        mobileMenuBtn && mobileMenuBtn.addEventListener('click', () => {
            toggleMobileMenu();
        })
        showNestedLevelLinks && showNestedLevelLinks.forEach(el => {
            el.addEventListener("click", (e) => {
                showMobileNestedLevel(e);
            })
        })
        closeNestedLevelLinks && closeNestedLevelLinks.forEach(el => {
            el.addEventListener("click", (e) => {
                closeMobileNestedLevel(e);
            })
        })
        window.addEventListener("resize", () => {
            updateNavOffsets();
            if (body.classList.contains('menu-opened') && window.innerWidth >= mobileNavBreakpoint) {
                closeMenu();
            }
        })
        window.addEventListener("primis:header-layout-changed", updateNavOffsets);
        mobileSearchOpen && mobileSearchOpen.addEventListener("click", function(e) {
            e.preventDefault();
            siteSearchBar.classList.add("show");
            siteSearchBar.querySelector(".site-search .ui-autocomplete-input").focus();
        })
        mobileSearchClose && mobileSearchClose.addEventListener("click", function(e) {
            siteSearchBar.classList.remove("show");
            mobileSearchOpen.focus();
        })
    }
    function toggleMobileMenu() {
        mobileMenuBtn.classList.contains('active') ? closeMenu() : openMenu();
    }
    function openMenu(e) {
        updateNavOffsets();
        mainNav.classList.add('opened');
        // overlay.classList.add('show');
        body.classList.add('menu-opened');
        mobileMenuBtn.classList.add("active");
    }
    function closeMenu(e) {
        mainNav.classList.remove('opened');
        // overlay.classList.remove('show');
        body.classList.remove('menu-opened');
        mobileMenuBtn.classList.remove('active');
        mainNav.querySelectorAll('.show').forEach(el => el.classList.remove('show'))
    }
    function closeMobileNestedLevel(e) {
        e.target.closest("ul").classList.remove('show');
    }
    function showMobileNestedLevel(e) {
        e.preventDefault();
        if (window.innerWidth < mobileNavBreakpoint) {
            updateNavOffsets();
            e.currentTarget.parentNode.querySelector('ul').classList.add('show');
        }
    }
    function updateNavOffsets() {
        if (!mainNav) {
            return;
        }

        siteHeader = document.querySelector(".site-header") || document.querySelector("header");
        if (!siteHeader) {
            return;
        }

        const headerBottom = siteHeader.getBoundingClientRect().bottom;
        const headerOffset = `${Math.max(headerBottom, 0)}px`;

        mainNav.style.setProperty('--site-header-offset', headerOffset);

        if (window.innerWidth < mobileNavBreakpoint) {
            mainNav.style.setProperty('--mobile-nav-offset', headerOffset);
        }
    }
    function init() {
        updateNavOffsets();
        attachEvents();
    }
    return {
        init: init
    }
}());

window.addEventListener('load', function() {
    HeaderComponent.init();
});


